import { useStaticQuery, graphql } from "gatsby"

export const useNavbarData = () => {
  const data = useStaticQuery(graphql`
    query navbar {
      allContentfulNavbarNavbarLinksJsonNode {
        edges {
          node {
            navbarLinks {
              text
              to
            }
          }
        }
      }
    }
  `)

  return data.allContentfulNavbarNavbarLinksJsonNode.edges[0].node
}

